<section class="gantt-container">
  <!-- Action Buttons -->
  <div class="action-buttons-container">
    <button class="action-btn action-btn-task" (click)="openTaskDialog()">
      <span class="material-icons">add_task</span>
      <span>Add Activity Task</span>
    </button>
  </div>

  <!-- Navigation Controls -->
  <div class="gantt-navigation">
    <button class="btn btn-nav-large" (click)="previousMonth()">
      <span class="material-icons">chevron_left</span>
    </button>

    <div class="month-nav-display">
      <div class="month-nav-item prev">
        <span class="month-nav-date">{{ getPreviousMonthLabel() }}</span>
      </div>

      <div class="month-nav-item current">
        <span class="month-nav-date highlighted">{{ currentMonthLabel() }}</span>
        <span class="current-badge">VIEWING</span>
      </div>

      <div class="month-nav-item next">
        <span class="month-nav-date">{{ getNextMonthLabel() }}</span>
      </div>
    </div>

    <button class="btn btn-nav-large" (click)="nextMonth()">
      <span class="material-icons">chevron_right</span>
    </button>

    <button class="btn btn-today" (click)="goToToday()">Today</button>
  </div>

  <!-- Filter Controls -->
  <div class="gantt-filter">
    <div class="filter-header">
      <span class="filter-title">Filter by Project:</span>
      <label class="filter-checkbox select-all">
        <input type="checkbox" [checked]="areAllProjectsSelected()"
          (change)="$event.target.checked ? selectAllProjects() : deselectAllProjects()">
        <span class="filter-checkbox-content">
          <span class="filter-label">Select All</span>
        </span>
      </label>
    </div>
    
    
    <div class="filter-items">
      <!-- Select All option -->


      <label class="filter-checkbox" *ngFor="let project of projects">
        <input type="checkbox" [checked]="isProjectSelected(project.id)" (change)="toggleProjectFilter(project.id)">
        <span class="filter-checkbox-content">
          <span class="filter-color-swatch" [style.background-color]="project.code"></span>
          <span class="filter-label">{{ project.name }}</span>
        </span>
      </label>
    </div>

    <!-- <div class="filter-toggle-all">
      <label class="filter-checkbox select-all">
        <input type="checkbox" [checked]="areAllProjectsSelected()"
          (change)="$event.target.checked ? selectAllProjects() : deselectAllProjects()">
        <span class="filter-checkbox-content">
          <span class="filter-label">Select All</span>
        </span>
      </label>
    </div> -->
  </div>

  <!-- Gantt Chart -->
  <div class="gantt-chart-wrapper">
    <!-- Headers Container (Sticky) -->
    <div class="gantt-headers-container">
      <!-- Left Panel Headers -->
      <div class="gantt-left-headers">
        <div class="gantt-left-header">
          <span class="left-header-title">Color Code</span>
        </div>
        <div class="gantt-left-header">
          <span class="left-header-title">Project</span>
        </div>
      </div>

      <!-- Right Panel Headers -->
      <div class="gantt-right-headers">
        <div class="gantt-timeline-header-grid">
          <!-- Month Separators in Header -->
          <div class="month-separator month-separator-header" *ngFor="let position of monthSeparatorPositions"
            [style.left.%]="position"></div>

          <!-- Timeline Header - Month Row -->
          <div class="gantt-timeline-header-months">
            <div class="timeline-month-cell" *ngFor="let monthGroup of monthGroups"
              [style.grid-column]="'span ' + monthGroup.weeks.length">
              <div class="month-cell-content">
                <span class="month-name">{{ monthGroup.monthName }}-{{ monthGroup.year }}</span>
              </div>
            </div>
          </div>

          <!-- Timeline Header - Week Dates Row -->
          <div class="gantt-timeline-header">
            <div class="timeline-column-header" *ngFor="let week of weekHeaders">
              <div class="week-header-content">
                <span class="week-date">{{ week.mondayDate | date: 'd' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Container (Scrollable) -->
    <div class="gantt-content-container">
      <!-- Left Panel: Project Names -->
      <div class="gantt-left-panel">
        <div class="gantt-projects-list">
          <div class="gantt-project-row" *ngFor="let project of getVisibleProjects()"
            [style.height]="getRowHeight(project)">
            <div class="project-color-swatch" [style.background-color]="project.code"></div>
            <div class="project-name">{{ project.name }}</div>
          </div>
        </div>
      </div>

      <!-- Right Panel: Timeline Grid -->
      <div class="gantt-right-panel">
        <!-- Month Separators -->
        <div class="month-separator" *ngFor="let position of monthSeparatorPositions" [style.left.%]="position"></div>

        <!-- Timeline Grid with Activities -->
        <div class="gantt-timeline-grid">
          <!-- Activity Rows - Dynamic height based on overlaps -->
          <div class="gantt-project-timeline" *ngFor="let project of getVisibleProjects()"
            [style.height]="getRowHeight(project)">
            <div class="gantt-activity-row">
              <!-- Activity Bars - Multiple activities per project row -->
              <div class="gantt-row-content">
                <ng-container *ngFor="let activity of project.activities">
                  <div class="activity-bar" *ngIf="calculateActivityPosition(activity).isVisible"
                    [style]="getActivityBarStyle(activity, project.code, project.activities)"
                    [matTooltip]="getActivityTooltip(activity, project)" matTooltipClass="activity-tooltip">
                    <div class="activity-bar-label">
                      {{ activity.name }}
                    </div>
                    <div class="activity-bar-actions" (click)="$event.stopPropagation()">
                      <button type="button" class="activity-icon-btn" (click)="onEditActivity(project.id, activity)">
                        <span class="material-icons">edit</span>
                      </button>
                      <button type="button" class="activity-icon-btn"
                        (click)="onDeleteActivity(project.id, activity.id)">
                        <span class="material-icons">delete</span>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Add Task Dialog Template -->
<ng-template #taskDialogTemplate>
  <div class="dialog-container task-dialog-simple">
    <div class="dialog-header-simple">
      <h2 mat-dialog-title>{{ isEditingTask ? 'Edit Activity Task' : 'Add Activity Task' }}</h2>
      <button mat-icon-button class="close-btn-simple" mat-dialog-close>
        <span class="material-icons">close</span>
      </button>
    </div>

    <mat-dialog-content class="dialog-body-simple">
      <div class="form-group">
        <label class="form-label">Select Project</label>
        <mat-form-field class="project-select-field" appearance="outline">
          <mat-select [(ngModel)]="newTask.projectId" placeholder="Select a project" [disabled]="isEditingTask">
            <mat-option *ngFor="let proj of activeProjs" [value]="proj.id">
              <span class="project-option" [class.project-option-disabled]="isEditingTask">
                <span class="project-color-dot" [style.background-color]="proj.code"></span>
                {{ proj.name }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group">
        <label class="form-label">Task Name</label>
        <input type="text" class="form-input-simple" [(ngModel)]="newTask.name" placeholder="Enter task description">
      </div>

      <div class="form-group">
        <label class="form-label">Date Range</label>
        <mat-form-field class="date-range-field" appearance="outline">
          <mat-label>Select date range (mm/dd/yyyy)</mat-label>
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate [(ngModel)]="newTask.startDate" placeholder="mm/dd/yyyy">
            <input matEndDate [(ngModel)]="newTask.endDate" placeholder="mm/dd/yyyy">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-footer-simple">
      <button mat-button class="btn-cancel-simple" mat-dialog-close>Cancel</button>
      <button class="btn-create-project" (click)="addNewTask()" [disabled]="!canAddTask()">
        {{ isEditingTask ? 'Save Changes' : 'Add Task' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>